import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonResult } from '../core/json-result.model';
import { LogPrivacyDataModel } from '../models/log-privacy-data.model';
import { ServiceRequestLogPrivacyData } from '../models/service-request/service-request-privacy-data.model';

import { HttpBackend, HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil, delay } from 'rxjs/operators';
import { DataPrivacy1LogInsertDTO } from '../models/privacity-data-insert';

@Injectable({
  providedIn: 'root'
})
export class LogPrivacyDataService {

  controller = 'LogPrivacyData';

  constructor(private httpClient: HttpClient,
    private handler: HttpBackend,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }

  sendInsertPrivacyData(data: DataPrivacy1LogInsertDTO) {
    //console.log(" ***** log-privacy.service sendInsertPrivacyData", data);
    const url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/InsertPrivacyData`;
    return this.httpClient.post<JsonResult<any>>(url, data).toPromise();
  }

  GetLogPrivacyData(params: ServiceRequestLogPrivacyData): Observable<JsonResult<any>> {
    //this.httpClient = new HttpClient(this.handler);
    const authToken = localStorage.getItem("token");
    const httpOptions = {
      headers: new HttpHeaders({
        "X-Skip-Interceptor": '',
        "Authorization": `Bearer ${authToken}`,
      })
    };

    console.log("<<<<<<<<<<<<<<<< GetLogPrivacyData",params);
    console.log("<<<<<<<<<<<<<<<< GetLogPrivacyData httpOptions",httpOptions);
    const url = `${this.environmentService.virtualOfficeServiceUrl}${this.controller}/GetPrivacyIsAcceptedByType`;
    return this.httpClient.post<JsonResult<LogPrivacyDataModel[]>>(url, params, httpOptions).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }


}